// @need-translate
import {ApiStatusCodeVo} from './shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {TextTKey} from './type';

export const ApiStatusCodeToErrorMessage: {[index: string]: TextTKey} = {
  [ApiStatusCodeVo.RejectRegisterFor7DaysAfterUnRegister]: {
    text: '탈퇴 후 7일 내에는 재가입이 불가합니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.KakaoError]: {
    text: '카카오페이지 회원 가입에 실패하였습니다.\n다시 시도해주세요.',
    // @ts-expect-error
    textTKey: '',
  },
  [ApiStatusCodeVo.NoMappingDataError]: {
    text: '뽑기권을 뽑을 수 없습니다',
    textTKey: 'error_quest_info_is_not_exist',
  },
};
